window.casinoModule = window.casinoModule || {};
casinoModule.constants = window.casinoModule.constants || {};

casinoModule.utils = {
    canIUseWebP: function () {
        const elem = document.createElement('canvas');

        if (!!(elem.getContext && elem.getContext('2d'))) {
            // was able or not to get WebP representation
            return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
        }

        // very old browser like IE 8, canvas not supported
        return false;
    },
    createGoogleTagManagerEvent: function (eventObject) {
        if (window.dataLayer && this.getCookie('analytic') == "1") {
            eventObject.url = window.location.href;
            if (!window.dataLayer)
                window.dataLayer = [];
            window.dataLayer.push(eventObject);
        }
    },
    lazyImages: function () {
        let lazyImageObserver = null;

        const mountEventLazyLoadImages = function () {
            if (lazyImageObserver)
                lazyImageObserver.disconnect();
            lazyImageObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        let lazyImage = entry.target;
                        if (lazyImage.dataset.src) lazyImage.src = lazyImage.dataset.src;
                        if (lazyImage.dataset.srcset) lazyImage.srcset = lazyImage.dataset.srcset;
                        lazyImage.classList.remove("lazy");
                        lazyImageObserver.unobserve(lazyImage);

                        //frosmo - gtm gameImpressions event
                        if (lazyImage.dataset.lazyid) {
                            const game = casinoModule.constants.games.find(it => it.s == lazyImage.dataset.lazyid);

                            if (game) {
                                const brandName = casinoModule.constants.brands && casinoModule.constants.brands[game.bID].name;

                                const imgsrc = casinoModule.config.gameImagesUrl + brandName + "/" + casinoModule.utils.normalizeString(game.n);
                                const webP = casinoModule.config.canIUseWebP ? '.webp' : '.jpeg';
                                const imgBig = imgsrc + webP;

                                let kategorijeArray = [];

                                Object.keys(game.kt).forEach(key => {
                                    const filterKategorija = casinoModule.constants.categories.find(x => x.id == key);
                                    if (filterKategorija)
                                        kategorijeArray.push(filterKategorija.name);
                                });

                                casinoModule.utils.createGoogleTagManagerEvent({
                                    'event': 'gameImpressions',
                                    'products': [{
                                        'gameId': game.id,
                                        'name': game.n,
                                        'category': kategorijeArray ? kategorijeArray.join() : '',
                                        'vendor': casinoModule.constants.brands[game.bID],
                                        'image': imgBig,
                                        'launchUrl': `https://mcasino.supersport.hr/game/${casinoModule.constants.brands[game.bID].nameNormalizirano}/${casinoModule.utils.normalizeString(game.n)}`,
                                        'maintenance': game.p && game.p.indexOf("o") != -1 ? true : false,
                                        'new': game.p && game.p.indexOf("n") != -1 ? true : false,
                                        'exclusive': game.p && game.p.indexOf("ex") != -1 ? true : false,
                                    }]
                                });
                            }
                        }
                    }
                });
            },

                {
                    threshold: 0,
                    rootMargin: '70%'
                });

            let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
            let lazyImageDivs = [].slice.call(document.querySelectorAll("div.lazy"));

            lazyImages.forEach(function (lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });

            lazyImageDivs.forEach(function (lazyDiv) {
                lazyImageObserver.observe(lazyDiv);
            });
        }

        return {
            mountEventLazyLoadImages
        }
    }(),
    removeSpecialCharacters: function (string, isDesktop) {
        if (string != null) {
            string = string.split(' Mobile').join('');
            string = string.split(' ').join('-').toLowerCase();
            string = string.split('%60').join('');
            string = string.split('&').join('and');
            string = string.split('.').join('-');
            string = string.split(':').join('-');
            string = string.split('`').join('');
            string = string.split('’').join('');
            string = string.split("'").join('');
            string = string.split('"').join('');
            string = string.split('™').join('-tm');
            string = string.split('#').join('');
            string = string.split('+').join('-');
            string = string.split('*').join('');
            string = string.split('!').join('');
            string = string.split('?').join('');
            // Cleanup consecutive dashes
            string = string.split('--').join('-');
            return string.split('--').join('-');
        }
        return '';
    },
    normalizeString: function (value, isDesktop) {
        if (value) {
            return this.removeSpecialCharacters(value, isDesktop);
        }

        return '';
    },
    toMoneySeparatedWithDecimals: function (iznos, minimumFractionDigits, maximumFractionDigits) {
        minimumFractionDigits = minimumFractionDigits ? minimumFractionDigits : 2;
        maximumFractionDigits = maximumFractionDigits ? maximumFractionDigits : 2;

        if (iznos === undefined)
            return;

        if (typeof iznos != 'number')
            iznos = parseFloat(parseFloat(iznos.split('.').join('').replace(',', '.')).toFixed(maximumFractionDigits));

        return iznos.toLocaleString("hr-HR", {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits
        }).replace("EUR", "€").replace("eur", "€").trim();
    },
    toTimeFormatString: function (input) {
        var date = new Date(input);
        return ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
    },
    toDateFormatString: function (input) {
        var date = new Date(input);
        return ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear().toString() + '.';
    },
    generateRandomNumbers(seed, count) {
        var mathSeed = function (s) {
            var mask = 0xffffffff;
            var m_w = (123456789 + s) & mask;
            var m_z = (987654321 - s) & mask;

            return function () {
                m_z = (36969 * (m_z & 65535) + (m_z >>> 16)) & mask;
                m_w = (18000 * (m_w & 65535) + (m_w >>> 16)) & mask;

                var result = ((m_z << 16) + (m_w & 65535)) >>> 0;
                result /= 4294967296;
                return result;
            }
        }
        var myRandomFunction = mathSeed(seed);
        var result = [];
        for (let i = 0; i < count; i++)
            result.push(myRandomFunction());

        return result;
    },
    generateTodayRandomNumber(count) {
        const today = new Date();
        const tt = new Date(today.getFullYear(), today.getMonth(), today.getDate()) - new Date(2020, 1, 1);
        return casinoModule.utils.generateRandomNumbers(tt, count);
    },
    getCookie: function (name) {
        return RegExp('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)').exec(document.cookie)?.pop() || null;
    },
  };

casinoModule.repos = {
    favoritesRepo: function (restApiUrl, apiKey) {
        const favoritesUrl = `${restApiUrl}/favorites`;
        const create = function (igra) {
            return fetch(favoritesUrl, {
                method: 'POST',
                credentials: casinoModule.repos.base.credentials,
                headers: casinoModule.repos.base.headers(apiKey),
                body: JSON.stringify(igra)
            })
                .then(casinoModule.repos.base.checkResponse)
                .catch(casinoModule.repos.base.handleNetworkException);
        };
        const remove = function (igra) {
            return fetch(favoritesUrl, {
                method: 'DELETE',
                credentials: casinoModule.repos.base.credentials,
                headers: casinoModule.repos.base.headers(apiKey),
                body: JSON.stringify(igra)
            })
                .then(casinoModule.repos.base.checkResponse)
                .catch(casinoModule.repos.base.handleNetworkException);
        };

        return {
            create: create,
            remove: remove
        }
    },
    getSession: async function (restApiUrl, apiKey) {
        const sessionId = casinoModule.utils.getCookie("session_id")?.toLowerCase().replaceAll("-", "") || "";

        try {
            const response = await fetch(`${restApiUrl}/session/${sessionId}`, {
                method: 'GET',
                headers: casinoModule.repos.base.headers(apiKey),
                credentials: casinoModule.repos.base.credentials,
            });

            casinoModule.repos.base.checkResponse(response);
            const sessionData = await response.json();

            if (sessionData?.antiForgeryToken) {
                casinoModule.config.antiForgeryToken = sessionData.antiForgeryToken;
            } else casinoModule.config.antiForgeryToken = null;

            return sessionData;
        } catch (error) {
            casinoModule.repos.base.handleNetworkException(error);
        }
    },
    getGames: async function (restApiUrl, apiKey, isDesktop) {
        const response = await fetch(restApiUrl + '/games?mobileGames=' + !isDesktop, {
            headers: casinoModule.repos.base.headers(apiKey),
        });
        return await response.json();
    },
    getCategories: async function (restApiUrl, apiKey) {
        const response = await fetch(restApiUrl + '/categories', {
            headers: casinoModule.repos.base.headers(apiKey),
        });
        return await response.json();
    },
    getThemes: async function (restApiUrl, apiKey) {
        const response = await fetch(restApiUrl + '/themes', {
            headers: casinoModule.repos.base.headers(apiKey),
        });
        return await response.json();
    },
  };

casinoModule.config = {
    gameImagesUrl: 'https://cdn.supersport.hr/casino/gameimages/',
    canIUseWebP: casinoModule.utils.canIUseWebP(),
    antiForgeryToken: null
};

